import { render } from "./PrivatePromptsMain.vue?vue&type=template&id=45bbacf9&scoped=true"
import script from "./PrivatePromptsMain.vue?vue&type=script&lang=js"
export * from "./PrivatePromptsMain.vue?vue&type=script&lang=js"

import "./PrivatePromptsMain.vue?vue&type=style&index=0&id=45bbacf9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bbacf9"]])

export default __exports__